import { Amplify } from 'aws-amplify';

export const backendConfig = {
  environment: process.env.REACT_APP_BACKEND_ENV || 'dev',
  apiUrl: process.env.REACT_APP_API_URL || '',
  userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
  userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
};

if (backendConfig.userPoolId && backendConfig.userPoolClientId) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: backendConfig.userPoolId,
        userPoolClientId: backendConfig.userPoolClientId,
        loginWith: { email: true },
        signUpVerificationMethod: 'code',
        userAttributes: { email: { required: true }, given_name: { required: true }, family_name: { required: true } },
      },
    },
  });
}
